import { render } from "./Swatches.vue?vue&type=template&id=3e9acefe"
import script from "./Swatches.vue?vue&type=script&lang=js"
export * from "./Swatches.vue?vue&type=script&lang=js"

import "./Swatches.vue?vue&type=style&index=0&id=3e9acefe&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__